import { Grid, Switch, Typography } from '@mui/material';
import { memo, useCallback } from 'react';

import { UserPreferenceName } from '@modules/userPreferences';
import { useUpdateUserPreferences, useUserPreference } from '@/modules/userPreferences/hooks';

import { DEBUG_ACTION_SIZE, DEBUG_DESCRIPTION_SIZE } from './DebugModal';

const ShowFpsOnCanvasComponent = () => {
  const { updateUserPreference } = useUpdateUserPreferences();
  const canvasShowFps = useUserPreference(UserPreferenceName.CANVAS_SHOW_FPS);

  const onModelChange = useCallback(() => {
    updateUserPreference(UserPreferenceName.CANVAS_SHOW_FPS, !canvasShowFps);
  }, [updateUserPreference, canvasShowFps]);

  return (
    <>
      <Grid item xs={DEBUG_DESCRIPTION_SIZE}>
        <Typography>Show FPS on canvas</Typography>
      </Grid>
      <Grid item xs={DEBUG_ACTION_SIZE}>
        <Switch onChange={onModelChange} checked={canvasShowFps} />
      </Grid>
    </>
  );
};

export const ShowFpsOnCanvas = memo(ShowFpsOnCanvasComponent);
